import { Button, message, Popconfirm } from 'antd';
import { useMemo } from 'react';
import { useCompany } from '../hooks/company';
import { useRequest } from 'ahooks';
import { customerController } from '../api';

export default ({
  ids,
  onSuccess,
}: {
  ids?: I.ID[];
  onSuccess: () => void;
}) => {
  const { config, id: companyId } = useCompany();
  const canDrop = useMemo(() => {
    return !!ids?.length;
  }, [ids]);

  const { run, loading } = useRequest(
    () => {
      if (ids?.length) {
        return customerController.dropToIdleBatch(companyId, ids);
      }
      return Promise.reject(new Error('请选择客户'));
    },
    {
      manual: true,
      onSuccess: () => {
        onSuccess();
        message.success('抛入成功');
      },
      onError: (e) => {
        message.error(e.message || '抛入失败');
      },
    },
  );
  return (
    <Popconfirm
      title="确定抛入仓库吗？"
      onConfirm={() => run()}
      okText="确定"
      cancelText="取消"
    >
      <Button
        disabled={!canDrop}
        type="primary"
        loading={loading}
      >
        抛入仓库
      </Button>
    </Popconfirm>
  );
};
